<template>
  <div class="about">
    <headerCom></headerCom>
    <div class="bg">
      <img src="../assets/images/about-us/about-us.jpg" alt="" />
    </div>
    <div class="width title-box">
      <p class="title">我们的服务模式</p>
      <p class="line">—</p>
      <p class="title-en">OUR SERVICE MODEL IS</p>
    </div>
    <div class="width list-box">
      <div class="service">
        <div class="item">
          <div>
            <img src="../assets/images/about-us/icon01.png" alt="" />
          </div>
          <p>
            我们提供用户按需组织专业人员在公司本部、或用户单位驻场开发专业系统的服务。
          </p>
        </div>
        <div class="item">
          <div>
            <img src="../assets/images/about-us/icon02.png" alt="" />
          </div>
          <p>
            我们提供与行业合作单位联合开发大、中型数据资源系统的服务。
          </p>
        </div>
        <div class="item">
          <div>
            <img src="../assets/images/about-us/icon03.png" alt="" />
          </div>
          <p>
            我们按照行业用户要求提供开发迭代更新的产品《软件系统》服务。
          </p>
        </div>
        <div class="item">
          <div>
            <img src="../assets/images/about-us/icon04.png" alt="" />
          </div>
          <p>
            我们联合行业主管部门、行业协会、主用户方开发大中型管理平台提供软件开发、系统运维服务支撑。
          </p>
        </div>
      </div>
      <div class="post">
        <img src="../assets/images/about-us/post.png" alt="" />
      </div>
      <div class="width title-box">
        <p class="title">联系我们</p>
      </div>
      <div class="contact">
        <div class="info-box">
          <div class="info">
            <img src="../assets/images/about-us/info01.png" alt="" />
          </div>
          <div class="info">
            <img src="../assets/images/about-us/info02.png" alt="" />
          </div>
          <div class="info">
            <img src="../assets/images/about-us/info03.png" alt="" />
          </div>
          <div class="info">
            <img src="../assets/images/about-us/info04.png" alt="" />
          </div>
        </div>
        <div class="map-box">
          <div id="mymap"></div>
        </div>
        <div class="code-box">
          <!-- <img src="../assets/images/about-us/HRcode.png" alt="" /> -->
        </div>
      </div>
    </div>
    <!-- <img src="" alt="" srcset=""> -->
    <!-- <footerCom></footerCom> -->
  </div>
</template>
<script>
import footerCom from "../components/Footer";
import headerCom from "../components/header";
import AMapLoader from "@amap/amap-jsapi-loader";
import { articleListByPage } from "../api/newstendency.js";

export default {
  name: "newstendency",
  components: {
    footerCom,
    headerCom,
  },
  data() {
    return {
      httpUrl: process.env.VUE_APP_URL,
      pagination: {
        pageSize: 10,
        currentPage: 1,
        total: null,
      },
      articleList: [],
    };
  },
  methods: {
    // 跳转
    linkTo(path, id) {
      this.$router.push({
        path: path,
        query: {
          id: id,
        },
      });
    },

    handleCurrentChange(currentPage) {
      // console.log(currentPage);
      this.pagination.currentPage = currentPage;
      this.articleListByPageFun();
    },

    //  首次加载地图
    initMap() {
      AMapLoader.load({
        key: "65579e9432093bc246cec091fcff2d68",
        version: "2.0",
        plugins: ["AMap.Geocoder", "AMap.Geolocation"],
      })
        .then((AMap) => {
          // 显示地图
          this.map = new AMap.Map("mymap", {
            center: [120.025011, 30.288383],
            // center: this.mapCenter,
            zoom: 18,
            resizeEnable: true,
          });

          let marker = new AMap.Marker({
            // icon: "http://webapi.amap.com/theme/v1.3/markers/n/mark_b.png",
            icon: "static/image/point.png",
            position: [120.025011, 30.288383],
            offset: new AMap.Pixel(-10, -20),
          });
          // 创建纯文本标记
          var text = new AMap.Text({
            text: "杭州卓智力创信息技术有限公司",
            anchor: "center", // 设置文本标记锚点

            cursor: "pointer",
            position: [120.025011, 30.288383],
          });

          text.setMap(this.map);
          marker.setMap(this.map);

          // 定位
          /* this.geo = new AMap.Geolocation({
                        useNative: true,
                    });
                    this.geo.on("complete", this.geoComplete);
                    this.geo.on("fail", this.geoFail);

                    this.geoComplete(); */
        })
        .catch((e) => {
          // console.log(e);
        });
    },

    //列表
    articleListByPageFun() {
      articleListByPage(this.pagination)
        .then((res) => {
          if (res.code == 200) {
            this.articleList = res.data.list;
            this.pagination.total = res.data.total;
          }
        })
        .catch((err) => {
          this.$message(err.message);
        });
    },
  },
  created() {
    this.pagination.currentPage = 1;
    this.articleListByPageFun();
  },
  mounted() {
    this.initMap();
  },
};
</script>
<style lang="less" scoped>
//
/deep/.amap-overlay-text-container {
  margin-left: 1px;
  padding: 10px 20px;
  margin-bottom: 110px;
  border: none;
  font-weight: bold;
  text-align: center;
  font-size: 14px;
  color: #333333;
  box-shadow: 0 2px 6px 0 rgba(114, 124, 245, 0.5);
  &:after {
    content: " ";
    position: absolute;
    display: inline-block;
    width: 0;
    height: 0;
    border-left: 7px solid transparent;
    border-right: 7px solid transparent;
    border-top: 10px solid #ffffff;
    left: 111px;
    top: 37px;
  }
}
.about {
  .top {
    width: 100%;
    position: relative;
    .nav-box {
      position: absolute;
      top: 12px;
      left: 50%;
      transform: translateX(-50%);
      -webkit-transform: translateX(-50%); /* for Chrome || Safari */
      -moz-transform: translateX(-50%); /* for Firefox */
      -ms-transform: translateX(-50%); /* for IE */
      -o-transform: translateX(-50%); /* for Opera */
      height: 55px;
      z-index: 2000;
      padding-left: 20px;
      // padding-right: 50px;
      .logo {
        height: 55px;
        width: 137px;
        display: block;
        float: left;
      }
      color: #cccccc;
      font-size: 16px;
      .nav {
        float: right;
        height: 25px;
        line-height: 25px;
        margin-top: 15px;
        cursor: pointer;
        p {
          float: left;
          padding: 0 20px;
        }
      }
    }
  }

  .bg {
    width: 100%;
    height: auto;
  }
  .title-box {
    // position: relative;
    padding-bottom: 25px;
    // border-bottom: 2px solid #d6dcea;
    p {
      text-align: center;
    }
    .title {
      margin-top: 45px;
      font-size: 24px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #333333;
    }
    .line {
      font-size: 28px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #2e4c8c;
      height: 20px;
      line-height: 20px;
    }
    .title-en {
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #333333;
    }
  }
  .list-box {
    // width: 100%;
    padding-bottom: 100px;
    display: flex;
    flex-direction: column;

    .service {
      display: flex;
      flex-direction: row;
      justify-content: space-between;

      margin-top: 50px;

      .item {
        width: 24%;
        padding: 30px 20px;
        background: #ffffff;
        box-shadow: 3px 3px 5px 0px rgba(196, 196, 196, 0.73);
        // opacity: 0.47;
        border-radius: 4px;

        display: flex;
        flex-direction: column;
        align-items: center;
        div {
          width: 88px;
          height: 88px;
          img {
            width: 100%;
            height: auto;
          }
        }
        p {
          font-size: 18px;
          font-family: Source Han Sans CN;
          font-weight: 500;
          color: #666666;
          margin-top: 25px;
        }
      }
    }

    .post {
      width: 100%;
      margin-top: 30px;
      margin-bottom: 40px;
      img {
        width: 100%;
        height: auto;
      }
    }

    .contact {
      margin-top: 60px;
      display: flex;
      flex-direction: column;

      position: relative;
      .info-box {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        .info {
          img {
            height: 40px;
            width: auto;
          }
        }
      }
      .map-box {
        height: 650px;
        // background-color: aquamarine;
        margin-top: 20px;
        #mymap {
          width: 100%;
          height: 100%;
          // position: fixed;
          /deep/ .amap-icon {
            img {
              width: 20px;
              height: auto;
            }
          }
        }
      }
      .code-box {
        position: absolute;
        right: -160px;
        bottom: 0;
        img {
          width: 160px;
          height: auto;
        }
      }
    }
  }
}
/deep/ .el-pagination {
  margin-top: 50px;
  text-align: end;
}

/deep/.amap-logo {
  display: none !important;
  visibility: hidden !important;
  opacity: 0 !important;
}

/deep/.amap-copyright {
  display: none !important;
  visibility: hidden !important;
  opacity: 0 !important;
}
@media screen and (max-width: 1650px) {
  .about .title-box .tips-box {
    font-size: 16px;
  }
  .about .title-box .tips-box img {
    width: 14px;
  }
}
@media screen and (max-width: 1450px) {
  .about .title-box .tips-box {
    font-size: 14px;
  }
  .about .title-box .tips-box img {
    width: 12px;
  }
}

/deep/.el-timeline-item__tail {
  // top: 50%;
  top: 0;
  left: 7px;
  padding-top: 10%;
  display: block !important;
}
/deep/ .el-timeline-item__node {
  top: calc(50% - 20px);
  background: url(../assets/images/line-time.png) no-repeat center center;
  background-size: 100% 100%;
  width: 18px;
  height: 18px;
  // margin-bottom: 10px;
}
</style>

<style>
.el-popper .popper__arrow::after {
  content: none;
}
.el-popper[x-placement^="bottom"] {
  margin-top: 0;
  margin-right: -30px;
  /* padding: 0 20px; */
}
.el-popper[x-placement^="bottom"] .popper__arrow {
  display: none;
}
.el-dropdown-menu {
  position: absolute;
  top: 0;
  left: 0;
  padding: 10px 0;
  margin: 0;
  background-color: rgba(0, 0, 0, 0.3);
  border: none;
  border-radius: 0;
  box-shadow: none;
}
.el-dropdown-menu__item {
  color: #ccc;
  width: 110px;
  text-align: center;
  background-color: rgba(0, 0, 0, 0) !important;
}
.el-dropdown-menu__item:hover {
  background-color: rgba(0, 0, 0, 0);
}
.el-dropdown-menu__item:focus {
  background-color: rgba(0, 0, 0, 0);
}
.el-dropdown {
  color: #ccc;
  font-size: 16px;
}
</style>
